import React, { useEffect, useState } from 'react';
import api from '../services/api';

const ROLES: Record<string, { label: string; icon: string; color: string }> = {
  gerente: { label: 'Gerente', icon: '👑', color: '#8B5CF6' },
  administrador: { label: 'Administrador', icon: '🛡️', color: '#0EA5E9' },
  cobrador: { label: 'Cobrador', icon: '🚶', color: '#38BDF8' },
  tecnico: { label: 'Técnico', icon: '🔧', color: '#F59E0B' },
  admin: { label: 'Admin (legacy)', icon: '👑', color: '#64748b' },
  soporte: { label: 'Soporte', icon: '🛠️', color: '#f59e0b' },
};

const Usuarios: React.FC = () => {
  const [usuarios, setUsuarios] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState<any>(null);
  const [form, setForm] = useState({ nombre: '', apellido: '', dni: '', email: '', telefono: '', password: '', rol: 'cobrador' });

  const cargar = async () => {
    setLoading(true);
    try { const res = await api.get('/usuarios'); setUsuarios(res.data); } catch {}
    finally { setLoading(false); }
  };

  useEffect(() => { cargar(); }, []);

  const abrirModal = (u?: any) => {
    setEditando(u || null);
    setForm(u ? { nombre: u.nombre, apellido: u.apellido, dni: u.dni || '', email: u.email, telefono: u.telefono || '', password: '', rol: u.rol }
      : { nombre: '', apellido: '', dni: '', email: '', telefono: '', password: '', rol: 'cobrador' });
    setModal(true);
  };

  const guardar = async () => {
    try {
      if (editando) await api.put(`/usuarios/${editando.id}`, form);
      else await api.post('/usuarios', form);
      setModal(false); cargar();
    } catch { alert('Error al guardar'); }
  };

  const eliminar = async (id: string) => {
    if (!window.confirm('¿Desactivar este usuario?')) return;
    try { await api.delete(`/usuarios/${id}`); cargar(); } catch {}
  };

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <div>
          <h2 style={{ color:'#f1f5f9', margin:0, fontSize:24, fontWeight:800 }}>👤 Usuarios</h2>
          <p style={{ color:'#64748b', margin:'4px 0 0', fontSize:13 }}>Gerentes, administradores, cobradores y técnicos del sistema</p>
        </div>
        <button onClick={() => abrirModal()}
          style={{ background:'#0ea5e9', border:'none', color:'white', padding:'10px 20px', borderRadius:10, cursor:'pointer', fontWeight:700, fontSize:14 }}>
          + Nuevo Usuario
        </button>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(5,1fr)', gap:12, marginBottom:20 }}>
        {[
          { label:'Total', value: usuarios.length, color:'#38bdf8' },
          { label:'Gerentes', value: usuarios.filter(u => ['gerente', 'admin'].includes(u.rol)).length, color:'#8B5CF6' },
          { label:'Admins', value: usuarios.filter(u => u.rol === 'administrador').length, color:'#0EA5E9' },
          { label:'Cobradores', value: usuarios.filter(u => u.rol === 'cobrador').length, color:'#38BDF8' },
          { label:'Técnicos', value: usuarios.filter(u => u.rol === 'tecnico').length, color:'#F59E0B' },
        ].map(s => (
          <div key={s.label} style={{ background:'#1e293b', borderRadius:10, padding:'14px 18px', border:`1px solid ${s.color}33` }}>
            <div style={{ color:'#64748b', fontSize:12 }}>{s.label}</div>
            <div style={{ color:s.color, fontSize:24, fontWeight:800 }}>{s.value}</div>
          </div>
        ))}
      </div>

      {loading ? <div style={{ color:'#64748b', textAlign:'center', padding:48 }}>Cargando...</div> :
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(300px,1fr))', gap:16 }}>
          {usuarios.map(u => {
            const rolInfo = ROLES[u.rol] || ROLES.cobrador;
            return (
            <div key={u.id} style={{ background:'#1e293b', borderRadius:12, padding:20, border:`1px solid ${u.activo ? '#334155' : '#ef444433'}` }}>
              <div style={{ display:'flex', alignItems:'center', gap:14, marginBottom:14 }}>
                <div style={{ width:48, height:48, borderRadius:'50%', background: `${rolInfo.color}22`, border:`2px solid ${rolInfo.color}`, display:'flex', alignItems:'center', justifyContent:'center', color: rolInfo.color, fontWeight:800, fontSize:20 }}>
                  {u.nombre[0]?.toUpperCase()}
                </div>
                <div>
                  <div style={{ color:'#f1f5f9', fontWeight:700, fontSize:15 }}>{u.nombre} {u.apellido}</div>
                  <div style={{ color:'#64748b', fontSize:12 }}>{u.email}</div>
                </div>
              </div>
              <div style={{ display:'flex', justifyContent:'space-between', marginBottom:14 }}>
                <span style={{ background: `${rolInfo.color}22`, color: rolInfo.color, border:`1px solid ${rolInfo.color}44`, borderRadius:20, padding:'3px 10px', fontSize:12, fontWeight:700 }}>
                  {rolInfo.icon} {rolInfo.label}
                </span>
                <span style={{ background: u.activo ? '#22c55e22' : '#ef444422', color: u.activo ? '#22c55e' : '#ef4444', border:`1px solid ${u.activo ? '#22c55e44' : '#ef444444'}`, borderRadius:20, padding:'3px 10px', fontSize:12, fontWeight:700 }}>
                  {u.activo ? 'Activo' : 'Inactivo'}
                </span>
              </div>
              {u.telefono && <div style={{ color:'#64748b', fontSize:12, marginBottom:12 }}>📱 {u.telefono}</div>}
              <div style={{ display:'flex', gap:8 }}>
                <button onClick={() => abrirModal(u)}
                  style={{ flex:1, background:'#1d4ed822', border:'1px solid #1d4ed844', color:'#60a5fa', borderRadius:8, padding:'8px', cursor:'pointer', fontWeight:600, fontSize:13 }}>
                  ✏️ Editar
                </button>
                <button onClick={() => eliminar(u.id)}
                  style={{ flex:1, background:'#ef444411', border:'1px solid #ef444433', color:'#ef4444', borderRadius:8, padding:'8px', cursor:'pointer', fontWeight:600, fontSize:13 }}>
                  🗑️ Desactivar
                </button>
              </div>
            </div>
            );
          })}
        </div>
      }

      {modal && (
        <div onClick={() => setModal(false)} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:9999 }}>
          <div onClick={e => e.stopPropagation()} style={{ background:'#1e293b', borderRadius:16, padding:28, width:440, border:'1px solid #334155' }}>
            <h3 style={{ color:'#f1f5f9', margin:'0 0 20px' }}>{editando ? '✏️ Editar Usuario' : '+ Nuevo Usuario'}</h3>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
              {[
                { label:'Nombre', key:'nombre' },
                { label:'Apellido', key:'apellido' },
                { label:'DNI', key:'dni' },
                { label:'Teléfono', key:'telefono' },
                { label:'Email', key:'email' },
                { label: editando ? 'Nueva contraseña (opcional)' : 'Contraseña', key:'password', type:'password' },
              ].map(f => (
                <div key={f.key}>
                  <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:6 }}>{f.label}</label>
                  <input value={(form as any)[f.key]} onChange={e => setForm({...form, [f.key]: e.target.value})}
                    type={f.type || 'text'}
                    style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'9px 12px', color:'white', fontSize:13, boxSizing:'border-box' }} />
                </div>
              ))}
            </div>
            <div style={{ marginTop:14 }}>
              <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:6 }}>Rol</label>
              <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
                {[
                  { v:'gerente', l:'👑 Gerente' },
                  { v:'administrador', l:'🛡️ Administrador' },
                  { v:'cobrador', l:'🚶 Cobrador' },
                  { v:'tecnico', l:'🔧 Técnico' },
                  { v:'admin', l:'⚪ Admin (legacy)' },
                ].map(r => (
                  <button key={r.v} onClick={() => setForm(f => ({...f, rol: r.v}))}
                    style={{ flex:'1 1 calc(33% - 8px)', padding:'10px', borderRadius:8, cursor:'pointer', fontWeight:700, border:`2px solid ${form.rol === r.v ? '#0ea5e9' : '#334155'}`, background: form.rol === r.v ? '#0ea5e922' : '#0f172a', color: form.rol === r.v ? '#38bdf8' : '#64748b' }}>
                    {r.l}
                  </button>
                ))}
              </div>
            </div>
            <div style={{ display:'flex', gap:10, marginTop:20 }}>
              <button onClick={() => setModal(false)} style={{ flex:1, background:'#334155', border:'none', color:'#94a3b8', borderRadius:8, padding:'10px', cursor:'pointer', fontWeight:600 }}>Cancelar</button>
              <button onClick={guardar} style={{ flex:1, background:'#0ea5e9', border:'none', color:'white', borderRadius:8, padding:'10px', cursor:'pointer', fontWeight:700 }}>Guardar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Usuarios;
